import { render } from "./SecondCardDesign.vue?vue&type=template&id=391a1ca4&scoped=true"
import script from "./SecondCardDesign.vue?vue&type=script&lang=js"
export * from "./SecondCardDesign.vue?vue&type=script&lang=js"

import "./secondCardDesign.scss?vue&type=style&index=0&id=391a1ca4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391a1ca4"]])

export default __exports__